import React from 'react';
import { Card, ListGroup, Badge } from 'react-bootstrap';
import { MapPin, Users, Phone, Star } from 'lucide-react';

const OfficeSelector = ({ locations, selectedOffice, onOfficeSelect }) => {
  const handleOfficeClick = (office, index) => {
    onOfficeSelect(office, index);
  };

  return (
    <Card className="office-selector-card border-0">
      <Card.Body className="p-0 office-selector-body">
        <ListGroup variant="flush">
          {locations.map((location, index) => {
            const isSelected = selectedOffice?.location_city === location.location_city;
            const showDetails = (selectedOffice && isSelected) || (!selectedOffice && location.headquarters);

            return (
              <ListGroup.Item
                key={index}
                action
                active={isSelected}
                onClick={() => handleOfficeClick(location, index)}
                className="border-0 office-selector-item"
                style={{ cursor: 'pointer' }}
              >
                <div className="d-flex justify-content-between align-items-start">
                  <div className="flex-grow-1">
                    <div className="d-flex align-items-center mb-2">
                      <h6 className="mb-0 me-2">{location.location_city}</h6>
                      {location.headquarters && (
                        <Badge className="office-hq-badge text-xs d-inline-flex align-items-center">
                          <Star size={10} fill="currentColor" className="me-1" />
                          HQ
                        </Badge>
                      )}
                    </div>
                    {showDetails && (
                      <>
                        <p className="text-muted mb-1 small">
                          {location.location_country?.label}
                        </p>
                        <div className="d-flex align-items-center text-muted small mb-1">
                          <MapPin size={14} className="me-2 office-icon text-dark flex-shrink-0" />
                          <span>{location.location_street}</span>
                        </div>
                        {location.location_size?.label && (
                          <div className="d-flex align-items-center text-muted small mb-1">
                            <Users size={14} className="me-2 office-icon text-dark flex-shrink-0" />
                            <span>{location.location_size.label}</span>
                          </div>
                        )}
                        {location.location_phone && (
                          <div className="d-flex align-items-center text-muted small">
                            <Phone size={14} className="me-2 office-icon text-dark flex-shrink-0" />
                            <span>{location.location_phone}</span>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </ListGroup.Item>
            )
          })}
        </ListGroup>
      </Card.Body>
    </Card>
  );
};

export default OfficeSelector;
